import styled from "styled-components";

import themeGet from "@/utils/theme-gets";

const QuickSearchContainer = styled.div`
  grid-area: workItem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
  height: 100%;
  padding: 0 0 0 0;

  [class^="dropdownMenuWrapper"] {
    left: -1px;
    width: calc(100% + 2px);
    margin-top: 3px;
    border-radius: ${themeGet("radii.l")};
    box-shadow: ${themeGet("shadow.m")};
    background-color: ${themeGet("color.background.surface.secondary")};
    animation-name: fadeIn;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      z-index: 999;
      transform: translateY(var(--dropdown-menu-fadinY, -75px));
    }
    100% {
      opacity: 1;
      z-index: 999;
      transform: translateY(0px);
    }
  }

  .board-dropdown {
    /* This style is used to remove free space in dropdown when input is disabled */
    input:disabled {
      margin-left: 0 !important;
    }

    /* This style is used for adding space to text when searching in the items input  */
    input:enabled {
      margin-left: 14px !important;
    }

    /*These styles are used to remove padding and margins from a dropdown using a regular expression to search for className*/
    [class^=" css-"]:first-child {
      margin: 0 !important;
      padding: 0 !important;

      [class$="-placeholder"] {
        margin-left: 14px !important;
        font: ${themeGet("typography.body.bolder.s")};
      }

      [class$="-singleValue"] {
        width: 100%;
        margin: 0;
        padding: 0;
      }
    }
  }
`;

export default QuickSearchContainer;
